import { FormattedNumber } from 'react-intl';
import { config } from '../../../utils/config';

const FormattedCurrency = ({ value }: { value: number }) => (
  <FormattedNumber
    value={value}
    style="currency"
    currency={config.currency}
    currencyDisplay={['ar_SA', 'en_IL', 'he_IL'].includes(config.locale) ? 'symbol' : 'code'}
  />
);

export default FormattedCurrency;
